import {
  clearConsultAnswersJSON,
  clearOrderItems,
  clearVisitID,
  getOrderComplete,
  getVisitID,
  setOrderComplete,
  setPostCheckoutInfo,
  setVisitProduct,
} from "~/visits/utils/visitCookies";
import { trackCheckout } from "./paymentHelpers";

export const KLARNA_CHECKOUT_PENDING = "P";
export const KLARNA_CHECKOUT_COMPLETE = "C";
export const KLARNA_CHECKOUT_CANCELED = "X";
export const KLARNA_CHECKOUT_EXPIRED = "E";
export const KLARNA_CHECKOUT_FAILED = "F";

export function klarnaReturnURL(
  consultationType,
  checkoutSessionID,
  attemptID,
) {
  const url = new URL(
    `/visits/${encodeURIComponent(consultationType)}/payment/payment-details`,
    window.location.origin,
  );
  url.searchParams.set("checkoutSessionID", checkoutSessionID);
  url.searchParams.set("klarnaAttempt", attemptID);
  return url.toString();
}

export function finishKlarnaCheckout(attempt, history) {
  if (attempt.status !== KLARNA_CHECKOUT_COMPLETE || !attempt.result?.visitID)
    return false;
  const { checkoutSessionID, result } = attempt;
  // Restore the minimal confirmation/Persona context even if storage was lost.
  // The authoritative checkout result came from an authenticated server call.
  if (
    !getOrderComplete(checkoutSessionID) &&
    getVisitID(checkoutSessionID) === result.visitID
  ) {
    trackCheckout(checkoutSessionID);
  }
  setVisitProduct(result.orderType, checkoutSessionID);
  setPostCheckoutInfo(
    {
      visitID: result.visitID,
      product: result.orderType,
      productSlug: result.orderType,
      orderItems: Object.fromEntries(
        (result.orderItems || []).map((item) => [item.consultationType, item]),
      ),
      consultationType: result.consultationType,
    },
    checkoutSessionID,
  );
  setOrderComplete(checkoutSessionID);
  clearVisitID(checkoutSessionID);
  clearOrderItems(checkoutSessionID);
  clearConsultAnswersJSON(checkoutSessionID);
  const params = new URLSearchParams({ checkoutSessionID });
  if (result.requiresIDVerification)
    params.set("requiresIDVerification", "true");
  if (result.subscriptionWillResume)
    params.set("subscriptionWillResume", "true");
  history.replace(
    `/visits/${encodeURIComponent(result.consultationType)}/payment/complete?${params}`,
  );
  return true;
}
